import englishImage from "../assets/english.png";

const data = {
  english: {
    image: englishImage,
    names: "Names",
    signin: "Sign In",
    email_address: "Email Address",
    phone_number: "Phone Number",
    login_text: "Login",
    forgot_password: "Forgot Password",
    names_required: "Names is required",
    phone_number_required: "Phone number is required",
    message_required: "Message is required",
    names_placeholder: "Enter your name",
    email_placeholder: "Enter your email address",
    phone_placeholder: "Enter your phone number",
    message_placeholder: "Type your message",
    email_required: "Email address is required",
    invalid_email_required: "Invalid email address",
    submit: "Submit",
    register: "Register",
    create_account: "Create Account",
    learn_more: "Learn More",
    password_placeholder: "Enter Password",
    welcome_title: "WELCOME!",
    password: "Password",
    reset_password_title: "Reset Password",
    new_password: "Enter new password",
    confirm_password: "Confirm Password",
    reset_password: "Reset Password",
    settings: "Settings",
    analytics: "Analytics",
    reset_password_title: "Reset Password",
    new_password: "Enter new password",
    confirm_password: "Confirm Password",
    reset_password: "Reset Password",
    map_insights: "Map Insights",
    reports: "Reports",
    donors: "Donors",
    requests: "Requests",
    dispatch: "Dispatch",
    haemovigilance: "Haemovigilance",
    mobilize: "Mobilize",
    Hospitals: "Hospitals",
    alerts: "Alerts",
    feedback: "Feedback",
    accounts: "Accounts",
    sites: "Sites",
    logout: "Logout",
    dashboard: "Dashboard",
    message: "Message",
    dont_have_account: "Don't have an account?",
    already_have_account: "Already have an account?",
    firstName: "First Name",
    lastName: "Last Name",
    all_fields_required: "All fields required",
    required: "required",
    first_name_placeholder: "Enter first name",
    name_name_placeholder: "Enter last name",
    business_Categories: "Business Categories",
    choice_business_Category: "Choose Business Category",
    business_category: "Business Category",
    unable_to_register: "Unable to create a new account",
    save_continue: "Save & Continue",
    back_view: "Back View",
    front_view: "Front View",
    upload: "Upload",
    legal_name: "Legal Name",
    build_business_profile: "Build Business Profile",
    legal_name_placeholder: "Enter business legal name",
    copy_kra_certificate: "A copy of the KRA PIN certificate",
    copy_national_id_front_back:
      "A copy of the National ID(Both front and back view)",
    stamped_bank_letter:
      "A duly stamped bank letter/cheque stating individuals bank details. (Account Number and Bank Code)",
    general_information: "General Information",
    bank_details: "Bank Details",
    business_address: "Business Address",
    account_number: "Account Number",
    account_number_placeholder: "Enter account number",
    bank_code: "Bank Code",
    bank_code_placeholder: "Enter bank code",
    postal_address: "Postal Address",
    postal_town: "Postal Town",
    location_name: "Location Name",
    country: "Country",
    city: "City",
    select: "Select",
    location_name_placeholder: "Enter location name",
    location_name_required: "Location name is required",
    city_required: "City is required",
    country_required: "Country is required",
    legal_name_required: "Legal name is required",
    account_number_required: "Account Number is required",
    bank_code_required: "Bank code is required",
    city_placeholder: "Enter city name",
    postal_address_placeholder: "Enter postal address",
    postal_code_placeholder: "Enter postal code",
    postal_town_placeholder: "Enter postal town",
    next: "Next",
    previous: "Previous",
    copy_national_id_owner:
      "A copy of the National ID(Both front and back view) documents of owner and/or contact person.",
    business_reg_number: "Business Registration Number",
    business_reg_number_placeholder: "Enter business registration number",
    copy_business_certificate:
      "Copy of Business Certificate of Registration or Business Permit",
    date_business_reg: "Date of Business Registration",
    date_business_reg_placeholder: "Date of Business Registration",
    business_nature: "Business Nature",
    business_nature_placeholder: "Enter business nature",
    trading_legal_names: "Both Trading and Legal names.",
    my_profile: "My Profile",
    change_password: "Change Password",
    home: "Home",
    unable_to_fetch_all_counties: "Unable to fetch all countries",
    country: "Country",
    name_placeholder: "Enter your name",
    name: "Name",
    invalid_email: "Invalid email address",
    country_required: "Country is required",
    name_required: "Name is required",
    account_created_successfully: "Account created successfully",
    unable_to_fetch_business_categories: "Unable to fetch business categories",
    business_category_required: "Business category is required",
    unable_create_business_category: "Unable to create business category",
    business_profile: "Business Profile",
    verifications: "Verifications",
    contacts: "Contacts",
    board_members: "Board Members",
    directors: "Directors",
    addresses: "Addresses",
    business_categories: "Business Categories",
    roles_permission: "Roles & Permissions",
    email_not_exist: "Email address does not exist",
    verify_email_title: "Verify Account",
    verify_email_description: "Enter your email address to verify your account",
    enter_otp_description: "Enter OTP code received on your email address ",
    otp_code_placeholder: "Enter OTP code",
    otp_code: "OTP Code",
    account_verification: "Account Verification",
    send: "Send",
    email_verification: "Email Verification",
    account_approval: "Account Approval",
    kyc_verification: "KYC Verification",
    unable_to_fetch_merchant_profile: "Unable to fetch merchant profile",
    approval_step_description:
      "Your account will be on hold until it is approved by the administrator",
    kyc_verification_step_description:
      "To ensure the security and compliance of our platform, we kindly request you to complete your KYC verification.",
    email_verification_step_description:
      "Please verify your email address to confirm ownership",
    account_verification_descriptions:
      "Please finalize your account verification process by following the steps below",
    proceed: "Proceed",
    go_back: "Go Back",
    user_id_missing: "User profile missing",
    resend_otp: "Resend OTP",
    otp_required: "OTP code is required",
    otp_resent_successfully: "OTP code has been resent successfully",
    resending: "Resending...",
    otp_resent_failed: "Resend OTP code failed",
    unable_to_verify_email_address: "Unable to verify email address",
    verify: "Verify",
    registration_number: "Registration Number",
    registration_number_placeholder: "Enter registration number",
    registration_date: "Registration Date",
    registration_date_placeholder: "Enter registration date",
    industry: "Industry",
    unable_to_fetch_industries: "Unable to fetch industries",
    create_business_profile: "Create Business Profile",
    unable_to_add_business_profile: "Unable to create Business Profile",
    add_business_profile_success: "Business Profile Added Successfully",
    registration_date_required: "Registration Date is Required",
    registration_number_required: "Registration Number is Required",
    add_address: "Add Address",
    edit: "Edit",
    delete_: "Delete",
    unable_to_fetch_address: "Unable to fetch addresses",
    location: "Location",
    town: "Town",
    city: "City",
    postal_address: "Postal Address",
    address: "Address",
    postal_address_required: "Postal Address is required",
    location_required: "Location is required",
    city_required: "City is required",
    town_required: "Town is required",
    add_address_failed: "Add Address Failed",
    unable_to_fetch_files: "Unable to fetch files",
    file_name: "File Name",
    file_type: "File Type",
    upload_file: "Upload File",
    delete_file_success: "File deleted successfully",
    delete_file_error: "Unable to delete file",
    delete_address_success: "Deleted Address successfully",
    delete_address_error: "Unable to delete address",
    upload_file_success: "File Uploaded successfully",
    upload_file_error: "Unable to upload file",
    actions: "Actions",
    upload_files: "Upload Files",
    industry_required: "Industry is required",
    close: "Close",
    cancel: "Cancel",
    required_documents: "Required Documents",
    director_added_success: "Director added successfully",
    director_added_error: "Unable to add director",
    unable_to_fetch_director: "Unable to fetch director",
    phone_required: "Phone number is required",
    create_business_profile: "Create Business profile",
    add_contact: "Add Contact",
    contact: "Contact",
    add_director: "Add Director",
    director: "Director",
    add_business_category: "Add Business Category",
    category: "Category",
    business_categories: "Business Categories",
    categories: "Categories",
    add_category_category: "Add Category",
    add_board_member: "Add Member",
    board_member: "Board Member",
    create_business: "Create Business",
    business: "Business",
    delete_business: "Delete Business",
    edit_business: "Edit Business",
    error_delete_business_profile: "Unable to delete business profile",
    success_delete_business_profile: "Business profile deleted successfully",
    update_business_profile_success: "Business profile updated successfully",
    unable_to_update_business_profile: "Unable to update business profile",
    file_name_placeholder: "Enter of the file ",
    file_name: "File Name",
    file_type: "File Type",
    contact_added_success: "Contact added successfully",
    contact_added_error: "Unable to add contact",
    contact_update_success: "Contact updated successfully",
    contact_update_error: "Unable to update contact",
    address_update_success: "Address updated successfully",
    address_update_error: "Unable to update address",
    address_added_error: "Unable to add address",
    director_update_success: "Director updated successfully",
    director_added_success: "Director added successfully",
    director_update_error: "Unable to update director",
    director_added_error: "Unable to add director",
    admin_login: "Admin Login",
    merchant_login: "Merchant Login",
    board_updated_error: "Unable to update board member",
    board_added_error: "Unable to add board member",
    board_updated_success: "Board member updated successfully",
    board_added_success: "Board member added successfully",
    industries: "Industries",
    verification_type_id_missing: "Verification type ID is missing",
    account_category: "Account Category",
    something_went_wrong: "Something went wrong",
    receive_otp_description: "We'll send you an otp code to your email address",
    otp_code: "OTP Code",
    otp_code_placeholder: "Enter otp code",
    verify_account: "Verify Account",
    enter_otp_received_on: "Enter OTP code received on",
    account_not_exist: "Account does not exist",
    new_password: "New Password",
    new_password_placeholder: "Enter new password",
    password_recovery_success: "Password recovery successful",
    password_recovery_error: "Unable to recover your password",
    upload_documents: "Upload Documents",
    is_mandatory: "is mandatory",
    build_business_profile_description:
      "This profile ensures secure transactions and compliance with financial regulations.",
    uploaded_documents: "Uploaded Documents",
    username: "Username",
    username_placeholder: "Enter username",
    country_placeholder: "Enter country",
    confirm_password_placeholder: "Confirm Password",
    password_not_match: "Password does not match",
    unable_to_view_uploaded_file: "Unable to view uploaded file",
    view_dashboard: "View Dashboard",
    file_has_been_uploaded: "Files have been uploaded successfully",
    view_file: "View File",
    my_files: "My Files",
    overview: "Overview",
    unable_to_fetch_accounts: "Unable to fetch your account",
    unable_to_fetch_active_channels: "Unable to fetch your channels",
    account_number: "Account Number",
    code: "Code",
    add_account: "Add Account",
    active_accounts: "Active Accounts",
    inactive_accounts: "Inactive Accounts",
    channel: "Channel",
    account_number_placeholder: "Enter Account Number",
    status: "Status",
    account_update_error: "Unable to update account",
    account_added_error: "Unable to add account",
    account_update_success: "Account Updated Successfully",
    account_added_success: "Account Added Successfully",
    account_number_required: "Account number is required",
    channel_required: "Channel is required",
    account: "Account",
    bank_required: "Bank is required",
    bank: "Bank",
    unable_to_fetch_banks: "Unable to fetch banks",
    inactive: "Inactive",
    active: "Active",
    unable_to_fetch_rates: "Unable to fetch rates",
    rates: "Rates",
    rate: "Rate",
    files_attached: "Files attached",
    unable_to_fetch_verifications: "Unable to fetch account verifications",
    analytics: "Analytics",
    total_revenues: "Total Revenues",
    total_transactions: "Total Transactions",
    no_data: "No data",
    unable_to_fetch_account_type: "Unable to fetch account type",
    account_type: "Account Type",
    wrong_email_password: "Wrong email or password",
    account_name_required: "Account name required",
    account_name: "Account Name",
    account_name_placeholder: "Enter account name",
    service_account: "Service Account",
    unable_to_fetch_service_account: "Unable to fetch service account",
    client_id: "Client ID",
    client_secret: "Client Secret",
    account_status: "Account Status",
    add_service_account: "Add Service",
    app_name: "App Name",
    view_service: "View Service",
    continue_to_your_account: "Continue to your account",
    unable_to_fetch_aggregator_categories:
      "Unable to fetch aggregator categories",
    unable_to_fetch_aggregators: "Unable to fetch aggregators",
    aggregators: "Aggregators",
    category_name: "Category Name",
    add_aggregator: "Add Aggregator",
    category_required: "Category is required",
    name_required: "Name is required",
    aggregator_update_success: "Aggregator updated successfully",
    aggregator_add_success: "Aggregator added successfully",
    aggregator_update_error: "Unable to update aggregator",
    aggregator_add_error: "Unable to add aggregator",
    name_placeholder: "Enter name",
    aggregator: "Aggregator",
    unable_to_fetch_collections: "Unable to fetch collections",
    collections: "Collections",
    add_collection: "Add collection",
    identifier: "Identifier",
    collection_required: "Collection is required",
    aggregator_required: "Aggregator is required",
    aggregator_collection_update_success:
      "Aggregator collection updated successfully",
    aggregator_collection_added_success:
      "Aggregator collection added successfully",
    aggregator_collection_update_error:
      "Unable to update aggregator collection",
    aggregator_collection_add_error: "Unable to update aggregator collection",
    unable_to_fetch_aggregator_collections:
      "Unable to fetch aggregator collection",
    view: "View",
    collection: "Collection",
    account_collection_update_success:
      "Account collection updated successfully",
    account_collection_added_success: "Account collection added successfully",
    account_collection_update_error: "Unable to update account collection",
    account_collection_add_error: "Unable to update account collection",
    unable_to_fetch_collection_accounts: "Unable to fetch collection accounts",
    account_required: "Account is required",
    created_at: "Created At",
    goto_dashboard: "Go to your Dashboard",
    charges: "Charges",
    unable_to_fetch_account_charges: "Unable to fetch account charges",
    charge_value_type: "Charge value type",
    charge_type: "Charge type",
    value: "Value",
    collection_account: "Collection Account",
    name_required: "Name is required",
    service_account_update_success: "Service account update successfully",
    service_account_added_success: "Service account added successfully",
    service_account_update_error: "Unable to update service account",
    service_account_added_error: "Unable to add service account",
    description: "Description",
    description_placeholder: "Enter description",
    add_service_account: "Add service account",
    service_account: "Service Account",
    unable_to_fetch_integration_profiles:
      "Unable to fetch integration profiles",
    integration_services: "Integration services",
    profiles: "Profiles",
    integration_profile_required: "Integration profile is required",
    profile_required: "Profile is required",
    unable_delete_file: "Unable to delete file",
    filed_deleted_successfully: "File deleted successfully",
    invalid_email: "Invalid email address",
    invalid_phone_number: "Invalid phone number",
    unable_fetch_business_profile: "Unable to fetch business profile",
    business_category_id_first:
      "Business category  is missing, please fill the form from business profile section",
    add_business_profile: "Add Business Profile",
    reports: "Reports",
    transactions: "Transactions",
    refund: "Refund",
    summary: "Summary",
    shifts:"Shifts",
    transaction_sub_type: "Sub Type",
    payment_mode: "Payment Mode",
    transaction_status: "Status",
    today: "Today",
    this_week: "This Week",
    this_month: "This Month",
    filter_by_date: "Filter by date",
    pending: "Pending",
    success: "Success",
    failed: "Failed",
    requires_authorization: "Requires Authorization",
    date: "Date",
    merchant: "Merchant",
    count: "Count",
    unable_fetch_organization_units: "Unable to fetch organization units",
    start: "Start",
    unable_to_fetch_merchant_id: "Unable to fetch merchant id",
    processor_transaction_id: "Processor transaction ID",
    total_reversal_amount: "Total reversed amount",
    payment_result: "Payment Result",
    unable_to_fetch_transactions_summary: "Unable to fetch transaction summary",
    unable_to_fetch_shifts: "Unable to fetch shifts",
    source: "Source",
    transaction_id: "Transaction ID",
    source: "Source",
    source_type: "Source Type",
    request_narration: "Request Narration",
    amount: "Amount",
    transaction_code: "Transaction Code",
    location_required: "Location is required",
    location_placeholder: "Enter location",
    country_required: "Country is required",
    tax_identification_number: "Tax Identification Number",
    tax_identification_number_placeholder: "Tax ID Number",
    tax_identification_number_required: "Tax identification number is required",
    national_identification_number_required:
      "National identification number is required",
    national_identification_number: "National ID Number",
    national_identification_number_placeholder:
      "Enter National Identification Number",
    unable_fetch_required_files: "Unable to fetch required business files",
    attachment: "Attachment",
    proceed: "Proceed",
    unable_to_fetch_daily_transactions: "Unable to fetch daily transaction",
    approved: "Approved",
    unable_to_fetch_collection_categories:
      "Unable to fetch collection categories",
    category_required: "Category is required",
    merchant_id: "Merchant ID",
    organization_name: "Organization Name",
    organization_name_placeholder: "Enter Organization Name",
    unable_to_fetch_core_integration_service:
      "Unable to fetch core integration services",
    title: "Title",
    type: "Type",
    service_code: "Service Code",
    payments: "Payments",
    invoices: "Invoices",
    create_invoice: "Create Invoice",
    reference_number: "Reference Number",
    date_issued: "Date Issued",
    reference_number_placeholder: "Enter Reference Number",
    invoice: "Invoice",
    due_date: "Due Date",
    item_name: "Item Name",
    item_name_placeholder: "Enter Item Name",
    add_item: "Add Item",
    remove: "Remove",
    item_required: "Item is required",
    amount_required: "Amount is required",
    reference_number_required: "Invoice number is required",
    date_issued_required: "Date issued is required",
    reference_number_required: "Invoice reference number is required",
    invoice_update_success: "Invoices updated successfully",
    invoice_added_success: "Invoices added successfully",
    quantity: "Quantity",
    customer_name: "Customer Name",
    customer_email: "Customer Email",
    customer_phone_number: "Customer Phone",
    customer_name_required: "Customer Name is required",
    customer_phone_required: "Customer Phone is required",
    invalid_phone_number: "Invalid phone number",
    customer_name_placeholder: "Enter Customer Name",
    customer_phone_number_placeholder: "Enter Customer Phone",
    customer_email_placeholder: "Enter Customer Email",
    invoice_date: "Invoice Date",
    merchant_name: "Merchant Name",
    source_type: "Source",
    source_type: "Source Type",
    reconciliation: "Reconciliation",
    run_number: "Run Number",
    transaction_date: "Transaction Date",
    label: "Label",
    processing_report: "Processing Report",
    activities: "Activities",
    settlements: "Settlements",
    reversals: "Reversals",
    total_settlement_fee: "Total Settlement Fee",
    settlement_batch: "Settlement Batch",
    batch_number: "Batch Number",
    settlement_amount: "Settlement Amount",
    wallet_balance: "Wallet Balance",
    wallet_type: "Wallet Type",
    available_balance: "Available Balance",
    created_by: "CreatedBy",
    debit: "Debit",
    credit: "Credit",
    fund_transfer_balance: "Fund Transfer",
    balance_id: "Balance ID",
    requests: "Requests",
    balances: "Balances",
    transaction_transfer_type: "Transaction transfer type",
    requestNarration: "Request Narration",
    balance: "Balance",
    shift_id: "Shift ID",
    shift_name: "Shift Name",
    shift_holder: "Shift Holder",
    transaction_amount: "Transaction Amount",
    transaction_confirmed_amount: "Transaction Confirmed Amount",
    transaction_count: "Transaction Count",
  },
};

export default data;
